import { injectReducer } from '../../store/reducers'
import { matchConstructor } from './modules/match'
export default (store) => ({
  path : 'match',
  
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Match = require('./containers/MatchContainer').default
      const reducer = require('./modules/match').default
      injectReducer(store, { key: 'match', reducer })
      store.dispatch(matchConstructor());
      cb(null, Match)
    }, 'match')
  }
})


// WEBPACK FOOTER //
// ./src/routes/Match/index.js